import { render, staticRenderFns } from "./callthepolice.vue?vue&type=template&id=18930908&"
import script from "./callthepolice.vue?vue&type=script&lang=js&"
export * from "./callthepolice.vue?vue&type=script&lang=js&"
import style0 from "./callthepolice.vue?vue&type=style&index=0&id=18930908&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports